document.addEventListener('DOMContentLoaded', () => {
  // Header
  const accordionHeaders = document.querySelectorAll(
    '.list-menu__accordion-header'
  );
  const megaMenu = $('.mega-menu');
  const updateReviewsUI = () => {
    const jdgmReviewWidget = document.querySelector('.jdgm-widget-revamp');
    const reviewTitle = document.querySelector('.jm-review-widget-header__title'); // to update review widget title  
    const rowActions = document.querySelector('.jm-review-widget__body'); // to add h2 inside this element, we just inserted h2 element to this

    if (!jdgmReviewWidget) {
      // console.log('jdgm-review-widget is not yet found');
      return;
    }

    const section = jdgmReviewWidget.closest('.shopify-section');
    if (section && !section.classList.contains('shopify-section-jdgm')) {
      section.classList.add('shopify-section-jdgm');
    }

    if (reviewTitle) {
      if (!reviewTitle.classList.contains('updated') || reviewTitle.textContent !== 'Reviews') {
        reviewTitle.textContent = 'Reviews';
        reviewTitle.classList.add('updated');
      }
    }

    if (rowActions && !rowActions.querySelector('.jdgm__reviews-title')) {
      const h2Element = document.createElement('h2');
      h2Element.className = 'jdgm__reviews-title';
      h2Element.textContent = 'Reviews';
      rowActions.prepend(h2Element);
    }
  };
  const observer = new MutationObserver(() => {
    updateReviewsUI();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  updateReviewsUI();

  const interval = setInterval(() => {
    updateReviewsUI();
  }, 1000);

  // exit observer after 5 seconds 
  setTimeout(() => {
    observer.disconnect();
    clearInterval(interval);
  }, 5000);
});